import { render } from "./MilestoneModal.vue?vue&type=template&id=4f58c395"
import script from "./MilestoneModal.js?vue&type=script&lang=js"
export * from "./MilestoneModal.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__